import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./features/LandingPage";
import { PaymentPlans } from "./features/PaymentPlans";
import TermsOfService from "./features/TermsOfService";
import PrivacyPolicy from "./features/PrivacyPolicy";
import RefundPolicy from "./features/RefundPolicy";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/plans" element={<PaymentPlans />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/refund" element={<RefundPolicy />} />
      </Routes>
    </Router>
  );
}
